!function (t, e) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = e(require("react-router-dom"), require("react"));else if ("function" === typeof define && define.amd) define(["react-router-dom", "react"], e);else {
    var r = "object" === typeof exports ? e(require("react-router-dom"), require("react")) : e(t["react-router-dom"], t.react);

    for (var n in r) {
      ("object" === typeof exports ? exports : t)[n] = r[n];
    }
  }
}(window, function (t, e) {
  return function (t) {
    var e = {};

    function r(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" === typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        r.d(n, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "/perseids-tools/react-router-i18n/", r(r.s = 2);
  }([function (e, r) {
    e.exports = t;
  }, function (t, r) {
    t.exports = e;
  }, function (t, e, r) {
    t.exports = r(3);
  }, function (t, e, r) {
    "use strict";

    r.r(e);
    var n = r(0);

    function o(t, e) {
      if (null == t) return {};

      var r,
          n,
          o = function (t, e) {
        if (null == t) return {};
        var r,
            n,
            o = {},
            u = Object.keys(t);

        for (n = 0; n < u.length; n++) {
          r = u[n], e.indexOf(r) >= 0 || (o[r] = t[r]);
        }

        return o;
      }(t, e);

      if (Object.getOwnPropertySymbols) {
        var u = Object.getOwnPropertySymbols(t);

        for (n = 0; n < u.length; n++) {
          r = u[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
        }
      }

      return o;
    }

    var u = r(1),
        i = r.n(u),
        c = function c(t) {
      var e = function e(_e) {
        var r = _e.to,
            n = _e.match,
            u = _e.ignoreLocale,
            c = (_e.staticContext, o(_e, ["to", "match", "ignoreLocale", "staticContext"])),
            a = n.params;
        if (u) return i.a.createElement(t, Object.assign({
          to: r,
          match: n
        }, c));
        var l = r;
        return a && a.locale && (l = "/" === l[0] ? "/".concat(a.locale).concat(l) : "".concat(a.locale, "/").concat(l)), i.a.createElement(t, Object.assign({
          to: l,
          match: n
        }, c));
      };

      return e.defaultProps = {
        ignoreLocale: !1,
        staticContext: void 0
      }, Object(n.withRouter)(e);
    };

    function a(t) {
      if (Array.isArray(t)) return t;
    }

    function l() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }

    function f(t, e) {
      return a(t) || function (t, e) {
        var r = [],
            n = !0,
            o = !1,
            u = void 0;

        try {
          for (var i, c = t[Symbol.iterator](); !(n = (i = c.next()).done) && (r.push(i.value), !e || r.length !== e); n = !0) {
            ;
          }
        } catch (a) {
          o = !0, u = a;
        } finally {
          try {
            n || null == c.return || c.return();
          } finally {
            if (o) throw u;
          }
        }

        return r;
      }(t, e) || l();
    }

    function p(t) {
      return a(t) || function (t) {
        if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
      }(t) || l();
    }

    var s = function s(t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    },
        d = function t(e, r) {
      if (!e) return null;
      var n = p(r),
          o = n[0],
          u = n.slice(1);
      return 0 === u.length ? s(e, o) ? e[o] : null : s(e, o) ? t(e[o], u) : null;
    },
        v = function v(t, e, r, o, u, i, c) {
      var a = function (t, e, r) {
        var o = Object(n.matchPath)(r, {
          path: t
        }).params;
        if (!o) return e;
        var u = o.locale;
        return u || e;
      }(t, e, r),
          l = o.split(".");

      if (s(i, a)) {
        var f = d(i[a], l);
        if (null !== f) return f;
      }

      var p = d(i[e], l);
      return null !== p ? p : void 0 !== u ? u : c;
    },
        y = function y(t, e, r, n, o, u, i, c) {
      var a = v(t, e, r, n, u, i, c);
      return "function" === typeof a ? a(o) : a;
    },
        b = function b(t, e) {
      var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          o = f(t, 1)[0],
          c = "/:locale(".concat(t.join("|"), ")?"),
          a = function a(t) {
        var n = t.location.pathname,
            a = t.children,
            l = t.t,
            f = t.args;
        return i.a.createElement(u.Fragment, null, y(c, o, n, l, f, a, e, r));
      };

      return a.getTranslation = function (t, n) {
        var u = t.pathname,
            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return y(c, o, u, n, i, void 0, e, r);
      }, a.defaultProps = {
        children: void 0,
        args: void 0
      }, Object(n.withRouter)(a);
    },
        m = c(n.Link),
        g = c(n.NavLink),
        h = c(n.Redirect);

    r.d(e, "createI18n", function () {
      return b;
    }), r.d(e, "Link", function () {
      return m;
    }), r.d(e, "NavLink", function () {
      return g;
    }), r.d(e, "Redirect", function () {
      return h;
    });
  }]);
});